export default "__VITE_ASSET__BKP6WcOB__"